// @ts-nocheck
import { ReactComponent as Icon } from '../../assets/icons/stationIcon.svg';

export default function () {
  return <Icon className="MuiSvgIcon-root" alt="Station" aria-label="Station" />;
}
